import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../api';

function clp(n) {
  return `$${Number(n || 0).toLocaleString('es-CL')}`;
}

function pct(cobrado, emitido) {
  if (!emitido) return '—';
  return `${Math.round((100 * cobrado) / emitido)}%`;
}

function EstadoPeriodo({ estado }) {
  const cls =
    estado === 'cerrado' ? 'badge badge-muted' : estado === 'publicado' ? 'badge badge-ok' : 'badge badge-warn';
  return <span className={cls}>{estado}</span>;
}

export default function CobranzaHistorialPage() {
  const { cid } = useParams();
  const [meses, setMeses] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    if (!cid) return Promise.resolve();
    setLoading(true);
    setError('');
    return api
      .get(`/gastos-comunes/condominios/${cid}/cobranza/historial`)
      .then((r) => setMeses(r.data.meses || []))
      .catch((e) => setError(e.response?.data?.error || e.message))
      .finally(() => setLoading(false));
  }, [cid]);

  useEffect(() => {
    localStorage.setItem('gc_condominio_id', cid);
    load();
  }, [cid, load]);

  return (
    <div className="page-historial-cobranza">
      <header className="ingresos-head">
        <div>
          <h1 className="page-title">Historial de cobranza</h1>
          <p className="page-lead page-lead-compact">
            Resumen por <strong>período de servicio</strong> (mes del gasto común). Abra un mes para ver cargos por
            unidad, pagos imputados e ingresos del mes calendario en que se cobró.
          </p>
          <p className="page-lead page-lead-compact">
            <Link to={`/c/${cid}/cobranza`}>← Cobranza operativa (mes en curso)</Link>
          </p>
        </div>
      </header>

      {error && <div className="alert alert-error">{error}</div>}
      {loading && <p className="empty-hint">Cargando historial…</p>}

      {!loading && (
        <div className="historial-resumen-table-shell">
          <table className="historial-resumen-table">
            <thead>
              <tr>
                <th>Período servicio</th>
                <th>Mes calendario cobro</th>
                <th>Estado</th>
                <th className="num">Emitido</th>
                <th className="num">Cobrado (imputado)</th>
                <th className="num">% cobro</th>
                <th className="num">Saldo pendiente</th>
                <th className="num">Unidades</th>
                <th className="num">Pagadas</th>
                <th className="num">Ingresos caja (mes cobro)</th>
                <th aria-label="Ver" />
              </tr>
            </thead>
            <tbody>
              {meses.map((m) => {
                const r = m.resumen || {};
                const key = m.periodoServicio?.key;
                return (
                  <tr key={key || m.periodoId}>
                    <td>
                      <strong>{m.periodoServicio?.label}</strong>
                    </td>
                    <td>{m.mesCalendarioCobro?.label}</td>
                    <td>
                      <EstadoPeriodo estado={m.estado} />
                    </td>
                    <td className="num">{clp(r.montoEmitido)}</td>
                    <td className="num">{clp(r.montoCobrado)}</td>
                    <td className="num">{pct(r.montoCobrado, r.montoEmitido)}</td>
                    <td className={`num ${r.saldoPendiente > 0 ? 'celda-pendiente' : ''}`}>{clp(r.saldoPendiente)}</td>
                    <td className="num">{r.unidadesConCargo ?? '—'}</td>
                    <td className="num">{r.unidadesPagadas ?? '—'}</td>
                    <td className="num" title={`${r.pagosRegistradosMesCalendario || 0} pagos`}>
                      {clp(r.ingresosCajaMesCalendario)}
                    </td>
                    <td>
                      <Link className="btn btn-sm secondary" to={`/c/${cid}/cobranza/historial/${key}`}>
                        Ver detalle
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {!meses.length && !error && (
            <p className="empty-hint">Aún no hay períodos con cargos. Abra un mes de cobro o publique cargos.</p>
          )}
        </div>
      )}
    </div>
  );
}
